export default __webpack_public_path__ + "static/media/subtract.dd8762d9.svg";